import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-attr-shape-06",
  "use": "icon-attr-shape-06-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-attr-shape-06\"><path d=\"M7.75 4c-.414 0-.75.298-.75.667v22.665c0 .594.808.891 1.28.472L16 20.942l7.72 6.862c.472.42 1.28.122 1.28-.472V4.667c0-.369-.336-.667-.75-.667z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol